import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import NotificationService from '../../services/NotificationService';
import { Notification as AppNotification } from '../../models/Notification';
import * as NotificationActions from './notification.actions';
import { catchError, map, mergeMap, of, tap } from 'rxjs';

@Injectable()
export class NotificationEffects {
  notify$;
  markAsRead$;
  createNotification$;
  loadNotifications$;
  loadNotificationsForCustomer$;
  markAllAsRead$;

  constructor(
    private actions$: Actions,
    private notificationService: NotificationService
  ) {
    this.loadNotifications$ = createEffect(() =>
      this.actions$.pipe(
        ofType(NotificationActions.loadNotifications),
        mergeMap(({ customerNo }) =>
          this.notificationService.getNotifications(customerNo).pipe(
            map((notifications: any[]) =>
              NotificationActions.loadNotificationsSuccess({
                notifications: notifications.map((n) => new AppNotification(n)),
              })
            ),
            catchError((error) =>
              of(NotificationActions.loadNotificationsFailure({ error }))
            )
          )
        )
      )
    );

    this.notify$ = createEffect(() =>
      this.actions$.pipe(
        ofType(NotificationActions.notify),
        mergeMap(({ message }) =>
          this.notificationService.notify(message).pipe(
            map(() => NotificationActions.notifySuccess()),
            catchError((error) =>
              of(NotificationActions.notifyFailure({ error }))
            )
          )
        )
      )
    );

    this.loadNotificationsForCustomer$ = createEffect(() =>
      this.actions$.pipe(
        ofType(NotificationActions.loadNotificationsForCustomer),
        mergeMap(() =>
          this.notificationService.loadNotificationsForCustomer().pipe(
            map((notifications) =>
              NotificationActions.loadNotificationsForCustomerSuccess({
                notifications: notifications.map((n) => new AppNotification(n)),
              })
            ),
            catchError((error) =>
              of(NotificationActions.loadNotificationsForCustomerFailure({ error }))
            )
          )
        )
      )
    );

    this.markAsRead$ = createEffect(() =>
      this.actions$.pipe(
        ofType(NotificationActions.markAsRead),
        mergeMap(({ id }) =>
          this.notificationService.markAsRead(id).pipe(
            map(() => NotificationActions.markAsReadSuccess({ id })),
            catchError((error) =>
              of(NotificationActions.markAsReadFailure({ error }))
            )
          )
        )
      )
    );

    this.createNotification$ = createEffect(() =>
      this.actions$.pipe(
        ofType(NotificationActions.createNotification),
        mergeMap(({ notification }) =>
          this.notificationService.createNotification(notification).pipe(
            map((created: any) =>
              NotificationActions.createNotificationSuccess({
                notification: new AppNotification(created),
              })
            ),
            catchError((error) =>
              of(NotificationActions.createNotificationFailure({ error }))
            )
          )
        )
      )
    );

    this.markAllAsRead$ = createEffect(() =>
      this.actions$.pipe(
        ofType(NotificationActions.markAllAsRead),
        map(() => NotificationActions.markAllAsReadSuccess()),
        catchError((error) => of(NotificationActions.markAllAsReadFailure({ error })))
      )
    );
  }
}
